import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import 'flickity-imagesloaded';

const ImageCarousel = (node) => {
	if (!node ) return false;

    const images = node.querySelectorAll('img');
    images.forEach(el => {
        if (el.width < el.height) {
            el.classList.add('is-portrait');
        } else {
            el.classList.add('is-landscape');
            el.classList.add('py-[25px]');
            el.classList.add('lg:py-[50px]');
            el.classList.add('2xl:py-[80px]');
        }
    })

    if(node.querySelector('.image-carousel-slider')){

        const flkty = new Flickity( node.querySelector('.image-carousel-slider'), {
            wrapAround: true,
            freeScroll: true,
            pageDots: false,
            autoPlay: 3000,
            pauseAutoPlayOnHover: false,
            selectedAttraction: 0.018,
            imagesLoaded: true,
            lazyLoad: true
        });

        node.querySelector('.image-carousel-slider').addEventListener('click', function(e) {
            const cursorActiveEvent = new Event("cursor-active");
            document.dispatchEvent(cursorActiveEvent);
            flkty.next();
            flkty.stopPlayer();
            flkty.playPlayer();
        });
    }

    if(node.querySelector('.image-carousel-slider-nowrap')){

        const shortFlkty = new Flickity( node.querySelector('.image-carousel-slider-nowrap'), {
            wrapAround: false,
            freeScroll: true,
            pageDots: false,
            autoPlay: 3000,
            pauseAutoPlayOnHover: false,
            selectedAttraction: 0.018,
            imagesLoaded: true
        });

        node.querySelector('.image-carousel-slider-nowrap').addEventListener('click', function(e) {
            const cursorActiveEvent = new Event("cursor-active");
            document.dispatchEvent(cursorActiveEvent);
            shortFlkty.next();
            shortFlkty.stopPlayer();
            shortFlkty.playPlayer();
        });
    }

}

export default ImageCarousel;